import { useQuery } from "@tanstack/react-query";
import { useAppContext } from "AppContext";
import { Navigate, Outlet } from "react-router-dom";
import axiosInstance from "utils/axiosInstance";

function PrivateRoute() {
  const isAuthenticated = localStorage.getItem("token");

  const { dispatch } = useAppContext();

  useQuery({
    queryKey: ["CURRENT_USER"],
    queryFn: async () => {
      const response = await axiosInstance.get("/user-details/");

      dispatch({ type: "CURRENT_USER", data: response?.data?.data });

      return response;
    },
  });

  return isAuthenticated ? <Outlet /> : <Navigate to="/" />;
}

export default PrivateRoute;
